import { KnmSearchInitFilterKeys } from '../types/KnmSearchInitFilterKeys';

const titleEnum = {
  frguOrgName: 'Наименование органа контроля (надзора)',
  prosecutorName: 'Наименование органа прокуратуры',
  subjectTypeCodes: 'Тип субъекта КНМ',
  knmType: 'Вид КНМ',
  year: 'Год проведения КНМ',
  supervisionName: 'Вид государственного надзора',
  organizationName: 'Наименование проверяемого лица',
  erpId: 'Учетный номер КНМ',
  inn: 'ИНН',
  ogrn: 'ОГРН',
  status: 'Статус КНМ',
  startMonth: 'Месяц даты начала проведения КНМ',
  federalLaws: 'Федеральный закон',
};

export const knmSearchFilterTitleMapper = (title: KnmSearchInitFilterKeys) => titleEnum[title];
